import { call, put, takeLatest } from 'redux-saga/effects'

import { postBrand, putBrand, deleteBrand } from '@galo-monitor/services/apis/galoMonitorApi/resources/brand'

import { BrandActions, BrandTypes } from './duckBrand'

function* saveBrand({ brand, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(brand.id ? putBrand : postBrand , brand)
    yield call(onSuccess)
  } catch (err) {
    yield put(BrandActions.brandError(err.message))
    yield call(onError, err)
  }
}

function* removeBrand({ brand, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteBrand, brand)
    yield call(onSuccess)
  } catch (err) {
    yield put(BrandActions.brandError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(BrandTypes.SAVE_BRAND, saveBrand),
  takeLatest(BrandTypes.REMOVE_BRAND, removeBrand)
]
